import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Text from '../../elements/Text';

const LocationSelectorGroupHeader = (props) => {
  const { children } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box className={className} style={style}>
      <Text>{children}</Text>
    </Box>
  );
};

LocationSelectorGroupHeader.propTypes = {
  /**
   * Text of the label.
   */
  children: PropTypes.string,
};

LocationSelectorGroupHeader.defaultProps = {
  children: null,
};

export default LocationSelectorGroupHeader;
